import { GUIDE_VERSION, type PresentationTarget } from './video-presentation.js';

/** Version two keeps the map full frame and places telemetry over its edges. */
export const SOCIAL_LAYOUTS = ['top-title', 'lower-title', 'side-rail', 'information-card'] as const;
export type SocialLayout = typeof SOCIAL_LAYOUTS[number];
export const SOCIAL_LAYOUT_LABELS: Record<SocialLayout, string> = {
  'top-title': 'Top title', 'lower-title': 'Lower title', 'side-rail': 'Side rail', 'information-card': 'Information card',
};
export const SUPPORTED_PRESENTATION_VERSIONS = [1, 2] as const;
export const SOCIAL_APPEARANCE_LIMITS = {
  titleSize: { min: 24, max: 80, default: 44 },
  statisticsSize: { min: 18, max: 60, default: 30 },
  extendedNumeralScale: { min: 30, max: 90, default: 60 },
  plateTransparency: { min: 0, max: 100, default: 20 },
  upperVerticalOffset: { min: -200, max: 200, default: 0 },
  lowerVerticalOffset: { min: -200, max: 200, default: 0 },
} as const;

export function presentationLayoutLabel(presentation: import('./video-presentation.js').VideoPresentation): string {
  if (presentation.version === 2) return SOCIAL_LAYOUT_LABELS[presentation.layout];
  return presentation.layout === 'map-focus' ? 'Map focus' : presentation.layout === 'compact' ? 'Compact' : 'Original';
}
export interface SocialVideoPresentation {
  readonly version: 2;
  readonly guideVersion: typeof GUIDE_VERSION;
  readonly target: PresentationTarget;
  readonly layout: SocialLayout;
  readonly titleSize: number;
  readonly statisticsSize: number;
  readonly extendedNumeralScale: number;
  readonly plateTransparency: number;
  /** Vertical offsets in pixels at a 1080-pixel video width; positive moves down. */
  readonly upperVerticalOffset: number;
  readonly lowerVerticalOffset: number;
  readonly textColor: string;
  readonly showTotals: boolean;
  readonly showElevation: boolean;
}
export function createSocialPresentation(target: PresentationTarget, layout: SocialLayout): SocialVideoPresentation {
  return { version: 2, guideVersion: GUIDE_VERSION, target, layout, titleSize: SOCIAL_APPEARANCE_LIMITS.titleSize.default,
    statisticsSize: SOCIAL_APPEARANCE_LIMITS.statisticsSize.default,
    extendedNumeralScale: SOCIAL_APPEARANCE_LIMITS.extendedNumeralScale.default,
    plateTransparency: SOCIAL_APPEARANCE_LIMITS.plateTransparency.default,
    upperVerticalOffset: SOCIAL_APPEARANCE_LIMITS.upperVerticalOffset.default,
    lowerVerticalOffset: SOCIAL_APPEARANCE_LIMITS.lowerVerticalOffset.default,
    textColor: '#ffffff', showTotals: false, showElevation: true };
}
